import { type ToolCall as AgUiToolCall } from '@ag-ui/client'
import { isRecord, parseJsonContent, parseToolCallArgumentsForDisplay } from 'shared/copilot/toolRegistry/parsing'
import { DATA_CHART_TOOL_NAME, dataChartSpecSchema, type CopilotDataChart } from './dataChartTypes'

/**
 * Builds a `create_data_chart` chart from its tool result. Only a successful,
 * server-validated response renders (a rejected call the agent retries leaves
 * nothing); the rows come from the call arguments, which the response omits.
 */
export const extractDataChartFromToolResult = (
  toolCall: AgUiToolCall,
  resultContent: unknown
): CopilotDataChart | null => {
  if (toolCall.function.name !== DATA_CHART_TOOL_NAME) return null

  const args = parseToolCallArgumentsForDisplay(toolCall.function.arguments)
  if (!isRecord(args) || !Array.isArray(args.data)) return null

  const response = parseJsonContent(resultContent)
  const payload = isRecord(response) && isRecord(response.result) ? response.result : response
  if (!isRecord(payload) || payload.status !== 'success') return null

  const spec = dataChartSpecSchema.safeParse(payload.chart)
  if (!spec.success) return null

  return {
    kind: 'dataChart',
    spec: spec.data,
    data: args.data.filter(isRecord),
    sourceCallId: toolCall.id
  }
}
